import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import AutocompleteField from 'components/molecules/Fields/AutocompleteField/AutocompleteField';

const StyledSuggestionField = styled(AutocompleteField)`
  .SuggestionField {
    &-adornment {
      padding-top: ${props => props.theme.layout(3)};
      padding-bottom: ${props => props.theme.layout(3)};

      border-radius: ${props => props.theme.radius(1)};
      margin: ${props => props.theme.layout(-2)} ${props => props.theme.layout(-2)} ${props => props.theme.layout(-2)} 0;

      .MuiButton-endIcon {
        margin-left: ${props => props.theme.layout(2)};
      }
    }
  }
  
  &.SuggestionField-hiddenAdornmentLabel {
    .SuggestionField {
      &-adornment {
        min-width: unset;
        padding-left: ${props => props.theme.layout(12)};
        padding-right: ${props => props.theme.layout(8)};
      }
    }
  }
  
  &.SuggestionField-size-smaller {
    .SuggestionField {
      &-adornment {
        min-width: unset;
        height: unset;
        margin-right: ${props => props.theme.layout(0.5)};
        padding-left: ${props => props.theme.layout(12)};
        padding-right: ${props => props.theme.layout(8)};
        padding-top: ${props => props.theme.layout(2)};
        padding-bottom: ${props => props.theme.layout(2)};
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledSuggestionField.propTypes = {
  theme: PropTypes.object
};

export default StyledSuggestionField;
